import React from 'react';

const PersonalizedNutrientProfileRows = (props) => {
  const {data} = props;
  const personalizedNutrientProfile = data.personalizedNutrientProfile;

  return (
    <tbody>
      {Object.keys(personalizedNutrientProfile).map((key, index) => (
        <tr key={index}>
          <td>{key}</td>
          <td>{personalizedNutrientProfile[key].dryMatter}</td>
          <td>{personalizedNutrientProfile[key].asFed}</td>
          <td>{personalizedNutrientProfile[key].per100kcal}</td>
          <td>{personalizedNutrientProfile[key].perMj}</td>
        </tr>
      ))}
    </tbody>
  );
}

export default PersonalizedNutrientProfileRows;
